import defaultConfig from '../../default'
import HeaderLogo from './HeaderLogo.svelte'
import type { GatewayConfig } from '../../declarations'
import ArticleIcon from 'images/icon-article.png'
import GalleryIcon from 'images/icon-gallery.png'
import MapIcon from 'images/icon-map.png'
import DatasetIcon from 'images/icon-dataset.png'
import GroupIcon from 'images/icon-group.png'
import DatasetDefinitionIcon from 'images/icon-dataset-definition.png'
import PersonIcon from 'images/icon-person.png'

export default {
  ...defaultConfig,

  gateway: 'piccc',
  title: window.gettext('Pacific Islands Climate Change Cooperative'),
  logoComponent: HeaderLogo,
  footer: [
    {
      label: window.gettext('ABOUT PICCC'),
      href: 'http://piccc.net/',
    },
    {
      label: window.gettext('ABOUT DATA BASIN'),
      href: '/about/',
    },
    {
      label: window.gettext('TERMS OF USE'),
      href: '/pages/terms-service/',
    },
    {
      label: window.gettext('CONTACT DATA BASIN'),
      href: '/services/contact/',
    },
  ],
  pages: {
    ...defaultConfig.pages,
    home: () => import('./Home.svelte'),
  },
  navigation: user => [
    {
      id: 'get-started',
      label: window.gettext('Get Started'),
      items: [
        {
          type: 'link',
          label: window.gettext('About the PICCC Planning Atlas'),
          href: '/pages/about-piccc/',
        },
        {
          type: 'link',
          label: window.gettext('Take a Tour'),
          href: '/tour/',
        },
        {
          type: 'link',
          label: window.gettext('Become a Member'),
          href: '/auth/create_account/',
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('Help'),
          href: '/help/',
          bold: true,
        },
        {
          type: 'link',
          label: window.gettext('Glossary'),
          href: '/glossary/',
          bold: true,
        },
      ],
    },

    {
      id: 'explore',
      label: window.gettext('Browse'),
      items: [
        {
          type: 'link',
          label: window.gettext('Use Cases'),
          image: ArticleIcon,
          href: '/articles/',
        },
        {
          type: 'link',
          label: window.gettext('Galleries'),
          image: GalleryIcon,
          href: '/galleries/',
        },
        {
          type: 'link',
          label: window.gettext('Maps'),
          image: MapIcon,
          href: '/maps/',
        },
        {
          type: 'link',
          label: window.gettext('Datasets'),
          image: DatasetIcon,
          href: '/datasets/',
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('Search Geographies or Keywords'),
          href: '/search/',
        },
      ],
    },

    {
      id: 'create',
      label: window.gettext('Create'),
      width: '245px',
      items: [
        {
          type: 'link',
          label: window.gettext('Create a Map'),
          image: MapIcon,
          href: '/maps/new/',
        },
        {
          type: 'link',
          label: window.gettext('Import a Dataset'),
          image: DatasetIcon,
          href: '/datasets/import/',
        },
        {
          type: 'link',
          label: window.gettext('Create a Group'),
          image: GroupIcon,
          href: '/groups/new/',
        },
        {
          type: 'link',
          label: window.gettext('Create a Gallery'),
          image: GalleryIcon,
          href: '/galleries/new/',
        },
        (user?.isContentAdmin || user?.isGatewayAdmin) && {
          type: 'link',
          label: window.gettext('Create a Use Case'),
          image: ArticleIcon,
          href: '/articles/new/',
        },
        user?.canCreateDefinition && {
          type: 'link',
          label: window.gettext('Create a Dataset Definition'),
          image: DatasetDefinitionIcon,
          href: '/datasets/definition/new/',
        },
      ],
    },
    defaultConfig.navigation(user).find(menu => menu.id === 'create'),
    {
      id: 'community',
      label: window.gettext('Community'),
      width: '215px',
      items: [
        {
          type: 'link',
          label: window.gettext('Members'),
          image: PersonIcon,
          href: '/people/',
        },
        {
          type: 'link',
          label: window.gettext('Groups'),
          image: GroupIcon,
          href: '/groups/',
        },
      ],
    },
  ],
} as GatewayConfig
